import { axiosInstance } from '@/http-common'

/**
 * Get user assets with pagination and filtering for DevExtreme DataGrid
 * @param params - Query parameters (skip, take, searchValue, sort, filter)
 */
export async function getUserAssets(params?: {
  skip?: number
  take?: number
  searchValue?: string
  sort?: any
  filter?: any
}): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/user-assets', { params })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get single user asset by ID with full details
 * @param id - User ID
 */
export async function getUserAsset(id: number | string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/user-asset/${id}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Check if email already exists in company
 * @param email - Email to check
 */
export async function checkUserAssetEmail(email: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/user-asset/check-email', {
      params: { email }
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}
